'use strict';

const $ = require('dibs-jquery-shim');
const User = require('../../../global/models/User');
const calloutHelper = require('../../../components/Callout/calloutHelper');
const calloutActions = require('../../../components/Callout/calloutActions');
const forceFavorite = require('../../../favorites/forceFavorite');
const {isPageType, pageTypes: {PAGE_TYPE}} = require('dibs-buyer-layout/src/entries/index');
const deviceTypeHelper = require('../../../global/utils/deviceTypeHelper');
const { autoModalHelpers: {wasModalShown} } = require('dibs-buyer-layout/src/entries/index');

/**
 * Opens save item callout.
 * React callout for PDP page,
 * backbone tooltip for browse pages.
 */

const openSaveItemCallout = function openSaveItemCallout({context, type}) {
    const isPdpPage = isPageType(PAGE_TYPE.PDP);

    if (isPdpPage) {
        if (!wasModalShown()) {
            context.executeAction(calloutActions.openCallout, { type });
        }
    } else {
        const wrap = function(element) {
            if (element) {
                element = element.wrap('<div>').parent();
            }
            return element;
        };

        const tooltipElement = $('#productsResults')
            .children()
            .first()
            .find('.js-favorite-icon');
        calloutHelper.showSaveItemCallout({ context, tooltipElement: wrap(tooltipElement) });
    }
};

/**
 * Checks user saved items.
 * Turns off Save Item callout if user has saved items.
 *
 * Returns resolved promise if user hasn't saved items,
 * returns rejected promise if user has saved items
 * @return {Promise}
 */
const hasUserSavedItems = function hasUserSavedItems() {
    const type = calloutHelper.CALLOUT_TYPE_SAVE_ITEM;
    const userModelClone = User.getCurrentUser().clone();
    let promise = Promise.resolve();

    if (User.loggedIn()) {
        promise = Promise.resolve(
            userModelClone.fetch({
                data: { fields: 'portfolio' },
            })
        );
    }

    return promise.then(() => {
        if (userModelClone.get('portfolio.itemCount')) {
            //turn off save item callout if user has saved items
            calloutHelper.saveToStorage({ type, turnOff: true });
            return true;
        }

        return false;
    });
};

/**
 * Checks is page type PDP/browse/search/attribute.
 * @return {boolean}
 */
const allowedPageType = function allowedPageType() {
    const allowedPages = [PAGE_TYPE.PDP, PAGE_TYPE.BROWSE, PAGE_TYPE.SEARCH, PAGE_TYPE.ATTRIBUTE];

    return isPageType(allowedPages);
};

/**
 * Checks condition for save item callout.
 * Opens callout if condition is satisfied.
 * Condition - it is browse, or search, or attribute or PDP page.
 * Not mobile web
 *
 * @return {Promise}
 */
const saveItemCalloutRule = function saveItemCalloutRule({ context }) {
    const type = calloutHelper.CALLOUT_TYPE_SAVE_ITEM;
    const isAllowedPageType = allowedPageType();
    const canShowCallout = calloutHelper.canShowCallout({ type });
    const favoriteForced = forceFavorite.isTypeForced(forceFavorite.TYPE_ITEM);
    const isMobile = deviceTypeHelper.isMobileOrTablet();

    if (!isMobile && !favoriteForced && canShowCallout && isAllowedPageType) {
        return hasUserSavedItems().then(hasItems => {
            if (!hasItems) {
                openSaveItemCallout({ context, type });
            }

            return { success: !hasItems, type };
        });
    }

    return Promise.resolve();
};

module.exports = saveItemCalloutRule;



// WEBPACK FOOTER //
// ./assets/js/global/notifications/rules/saveItemCalloutRule.es.js